// World constants - single source of truth
export const CHUNK_SIZE = 16;
export const CHUNK_HEIGHT = 256;
export const CHUNK_VOLUME = CHUNK_SIZE * CHUNK_HEIGHT * CHUNK_SIZE; // 4096
export const SEA_LEVEL = 63;
